import { render, staticRenderFns } from "./EmailVerificationSuccess.vue?vue&type=template&id=39381e04&scoped=true"
import script from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationSuccess.vue?vue&type=style&index=0&id=39381e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39381e04",
  null
  
)

export default component.exports